import React, { useState } from "react";
import { useCookies } from "react-cookie";
import { useGet } from "../services/GetService";
import Card from "react-bootstrap/Card";
import Key from "../util/Key";
import CardInfo from "./innerComponent/CardInfo";
import { FcAbout } from "react-icons/fc";
import { Link } from "react-router-dom";

const Panel = () => {
    const [cookies, setCookie, removeCookie] = useCookies(["user", "token"]);
    const [companies, setCompanies] = useGet("statistics/companies");

    return (
        <div className="container">
            <div className="row d-flex gap-2">
                {companies.map((company) => {
                    return (
                        <Link
                            to={`/details/${company.id}`}
                            key={Key()}
                            className="col-2 border rounded mt-3 p-2"
                            style={{ textDecoration: "none", color: "black" }}
                        >
                            <div className="name">
                                <h4>{company.name}</h4>
                            </div>
                            <p className="lh-1">
                                Formularios: {company.form.length}
                            </p>
                            <CardInfo key={Key()} id={company.id} />
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};
export default Panel;
